// ------------------------ vars ------------------------ //

window.steps = null
window.historyStep = 0

// ------------------------ form ------------------------ //

getIgnoreStepsArray = function () {
    const ignoreSteps = options.ignoreSteps

    return ignoreSteps.split(',')
}

setupForm = function () {
    window.addEventListener('popstate', popStateHandle)

    steps = Array.from(document.querySelectorAll('.form-step'))

    if (options.ignoreSteps) {
        const ignoreStepsArray = getIgnoreStepsArray()

        steps = steps.filter(function (value) {
            if (ignoreStepsArray.includes(value.id) === false) {
                return value
            }
        })
    }

    if (steps.length > 0) {
        stepShow(getStepKeyByID(options.stepInit))

        //binds
        steps.forEach((stepElement, stepKey) => {
            const stepElementName = stepElement.id //get fieldset id value

            //verify if setupBind function is defined
            if (typeof setupBind[stepElementName] !== 'undefined' && typeof setupBind[stepElementName] === 'function') {
                setupBind[stepElementName](stepElement, stepKey)
            } else {
                debug('Bind not defined for: ' + stepElementName)
            }
        })
    }

    document.querySelector('#' + options.formID).addEventListener('keypress', async function (event) {
        if (event.keyCode === 13) {
            event.preventDefault()

            const stepSelected = getStepSelected()
            const stepElement = steps[stepSelected]

            if (options.hideNextButton.includes(stepElement.id) === false) {
                await stepHandle(stepSelected)
            }
        }
    })

    setUserLanguage('userLanguage')
}

popStateHandle = async function (event) {
    if (document.location.pathname === options.resultsURL || historyStep === 999) {
        location.replace(options.startURL)

        return
    }

    let goStep = 0
    let directionStep = 'back'

    if (event.state !== null) {
        goStep = event.state.step
    }

    if (historyStep < goStep) {
        directionStep = 'forward'
    }

    historyStep = goStep

    if (directionStep === 'forward') {
        await stepHandle(getStepSelected(), true)
    } else {
        stepShow(goStep, true)
    }
}

stepNextButtonHtml = function (is_loading, stepID) {
    const defaultContent = {
        buttonFinal: '<span>Complete My Request</span>',
        buttonFirst: '<span>Next</span>',
        buttonNext: '<span>Next</span>',
        buttonLoading: '<span class="spinner-border" role="status" aria-hidden="true"></span> Loading...'
    }

    options.content = { ...defaultContent, ...options.content }

    if (is_loading === true) {
        return options.content.buttonLoading
    }

    if (stepID === options.stepFinal) {
        return options.content.buttonFinal
    }

    if (stepID === options.stepFirst) {
        return options.content.buttonFirst
    }

    return options.content.buttonNext
}

stepNextButtonCreate = function (stepSelected) {
    let stepElement = steps[stepSelected]
    let existingButton = getButtonElement(stepElement)

    //added for the autofill scenario
    const formElements = stepElement.querySelectorAll('.form-control')
    let stepValidStatus = true

    for (const formElement of formElements) {
        if (formElement.classList.contains('is-valid') === false) {
            stepValidStatus = false
            break
        }
    }

    //if button already exist do not create it
    if (typeof (existingButton) != 'undefined' && existingButton != null) {
        if (stepValidStatus === true) {
            existingButton.classList.remove('btn-disabled')
        }

        return
    }

    let p = document.createElement('p')
    p.className = 'commands'

    let btnDisabled = ''

    // enable by default `next` button
    if (options.defaultEnableNextButton && options.defaultEnableNextButton.includes(stepElement.id) === false && stepValidStatus === false) {
        btnDisabled = 'btn-disabled'
    }

    let button = document.createElement('button')
    button.className = 'btn btn-lg btn-warning submit ' + btnDisabled
    button.innerHTML = stepNextButtonHtml(false, stepElement.id)

    //hide `next` button
    if (options.hideNextButton && options.hideNextButton.includes(stepElement.id) === true) {
        button.style.display = 'none'
    }

    button.addEventListener('click', async (e) => {
        e.preventDefault()

        await stepHandle(stepSelected)
    })

    p.appendChild(button)

    if (typeof stepNextButtonAppend !== 'undefined' && typeof stepNextButtonAppend === 'function') {
        stepNextButtonAppend(stepElement, p)
    } else {
        stepElement.appendChild(p)
    }
}

stepNextButtonStatus = function (stepSelected, is_disabled) {
    let button = getButtonElement(steps[stepSelected])

    if (options.stepProgressEnabled === true) {
        updateProgress(stepSelected)
    }

    if (button) {
        if (is_disabled === true) {
            button.classList.add('btn-disabled')
        } else {
            button.classList.remove('btn-disabled')
        }
    }
}

stepNextButtonLoading = function (element, is_loading) {
    if (is_loading === false) {
        element.classList.remove('btn-loading')
        document.querySelector('.form-overlay').style.display = 'none'
    } else {
        element.classList.add('btn-loading')
        document.querySelector('.form-overlay').style.display = 'block'
    }
}

stepInputValid = function (ids) {
    let status = true

    for (const id of ids) {
        if (document.querySelector('#' + id).classList.contains('is-valid') === false) {
            status = false
            break
        }
    }

    return status
}

getStepDataByID = function (id) {
    let stepData = {
        'stepElement': null,
        'stepKey': null,
    }

    steps.forEach((stepElement, stepKey) => {
        if (stepElement.id === id) {
            stepData.stepElement = stepElement
            stepData.stepKey = stepKey
        }
    })

    return stepData
}

getStepKeyByID = function (name) {
    let stepKey = 0

    steps.forEach((element, key) => {
        if (element.id === name) {
            stepKey = key
        }
    })

    return stepKey
}

getStepSelected = function () {
    let stepSelected

    steps.forEach((element, key) => {
        if (element.classList.contains('form-step-show') === true) {
            stepSelected = key
        }
    })

    return stepSelected
}

getButtonElement = function (stepElement) {
    return stepElement.querySelector('p.commands button')
}

stepShow = function (stepSelected, doNotSetPushState = false) {
    if (typeof stepShowRules !== 'undefined' && typeof stepShowRules === 'function') {
        //update `stepSelected` value based on custom rules
        stepSelected = stepShowRules(stepSelected)
    }

    //vars
    historyStep = stepSelected

    //hide all steps
    steps.forEach((step) => {
        step.classList.remove('form-step-show')
    })

    //show selected step
    steps[stepSelected].classList.add('form-step-show')

    if (doNotSetPushState === false) {
        //url update
        const url = steps[stepSelected].dataset.url

        if (typeof url !== 'undefined' && url) {
            if (url !== window.location.pathname) {
                // window.history.replaceState({}, null, url)
                window.history.pushState({
                    'step': stepSelected
                }, null, url)
            }
        }
    }

    if (options.stepProgressEnabled === true) {
        stepProgress(stepSelected)
    }

    stepNextButtonCreate(stepSelected)

    if (options.smoothScrollingTo) {
        smoothScrollingTo(options.smoothScrollingTo)
    }

    if (typeof stepShowSetup !== 'undefined' && typeof stepShowSetup === 'function') {
        stepShowSetup(stepSelected)
    }

    if (typeof options.stepCallback !== 'undefined' && typeof options.stepCallback[steps[stepSelected].id] === 'function') {
        options.stepCallback[steps[stepSelected].id]()
    }
}

stepProgress = function (stepSelected) {
    let backProgressElement = document.querySelector('#progress-back')

    updateProgress(stepSelected)

    if (stepSelected === 0) {
        backProgressElement.style.display = 'none' //we are on initial step => hide back button
    } else {
        backProgressElement.style.display = 'block'

        document.querySelector('#progress-container').classList.add('progress-active') //show progress bar

        //use `onclick` because only one action can exist (note: addEventListener does not clear previous defined)
        document.querySelector('#progress-back').onclick = function (e) {
            if (e.target.dataset.history === 'false') {
                stepShow(stepSelected - 1)
            } else {
                window.history.back()
            }
        }
    }
}

updateProgress = function (stepSelected) {
    let stepsLength = steps.length
    let stepCount = stepSelected

    const minComplete = stepCount * 100 / stepsLength //calculate progress percentage
    const maxComplete = (stepCount + 1) * 100 / stepsLength //calculate progress percentage

    const stepID = steps[stepSelected].id
    // const stepComplete = calcStepProgress(stepID)
    // const complete = Math.round(minComplete + (maxComplete - minComplete) * stepComplete)
    const complete = minComplete

    document.querySelector('#progress-complete').style.width = complete + '%'
    // document.querySelector('#progress-number').textContent = complete.toString()
}

stepHandle = async function (stepSelected, doNotSetPushState = false) {
    const stepElement = steps[stepSelected] //get fieldset element
    const button = getButtonElement(stepElement) //get next button element

    //button is in loading state => do nothing
    if (button.classList.contains('btn-loading') === true) {
        return
    }

    const stepElementName = stepElement.id //get fieldset id value

    //change button to loading
    button.innerHTML = stepNextButtonHtml(true, stepElementName)
    stepNextButtonLoading(button, true)

    let stepNext = stepSelected + 1 //set index for next step to display

    //verify if stepCheck function is defined
    if (typeof stepCheck[stepElementName] !== 'undefined' && typeof stepCheck[stepElementName] === 'function') {
        const error = await stepCheck[stepElementName](stepSelected, true, null, true)

        if (error === false) {
            stepNextButtonStatus(stepSelected, false) //enable `next` OR `submit` button
        } else {
            stepNextButtonStatus(stepSelected, true) //enable `next` OR `submit` button

            //error occurred => disable button loading
            button.innerHTML = stepNextButtonHtml(false, stepElementName)
            stepNextButtonLoading(button, false)
        }
    } else {
        stepNextButtonStatus(stepSelected, false) //enable `next` OR `submit` button
        debug('Check not defined for: ' + stepElementName)
    }

    //button is disabled => do nothing
    if (button.classList.contains('btn-disabled') === true) {
        return
    }

    if (typeof stepSave !== 'undefined' && typeof stepSave[stepElementName] !== 'undefined' && typeof stepSave[stepElementName] === 'function') {
        await stepSave[stepElementName](stepSelected)
    }

    if (stepElement.id === options.stepFinal) {
        submitHandle(button)

        //vars
        historyStep = 999
    } else {
        button.innerHTML = stepNextButtonHtml(false, stepElementName)
        stepNextButtonLoading(button, false)

        //display next step
        stepShow(stepNext, doNotSetPushState)
    }
}

// ------------------------ utility ------------------------ //

debug = function (data) {
    if (mdrvConfigData.environment !== 'production') {
        console.log(data)
    }
}

createElementFromHTML = function (string, tag = 'div') {
    let element = document.createElement(tag)
    element.innerHTML = string.trim()

    return element.firstChild
}

getFirstElementFromArray = function (a) {
    return a.at(0)
}

getLastElementFromArray = function (a) {
    return a.at(-1)
}

getUrlParam = function (param) {
    const url = new URL((window.location.href))

    return url.searchParams.get(param)
}

googleTriggerEvent = function (name) { //used for GTM triggers
    window.dataLayer = window.dataLayer || []
    window.dataLayer.push({
        'event': name
    })
}

keyCodeIgnore = function (event) {
    const key = event.keyCode

    return (
        (key === 13) ||
        (key === 229) ||
        (key > 36 && key < 41) // left, up, right, down
    )
}

upKeyCodePhone = function (event) {
    const key = event.keyCode

    return (
        (key >= 48 && key <= 57) || // Allow number line
        (key >= 96 && key <= 105) || // Allow number pad
        (key === 189) || // Allow -
        (event.shiftKey === true || key === 35 || key === 36) || // Allow Shift, Home, End
        (key === 8 || key === 9 || key === 13 || key === 46) || // Allow Backspace, Tab, Enter, Delete
        (key > 36 && key < 41) || // Allow left, up, right, down
        (
            // Allow Ctrl/Command + A,C,V,X,Z,R
            (event.ctrlKey === true || event.metaKey === true) &&
            (key === 65 || key === 67 || key === 86 || key === 88 || key === 90 || key === 82)
        )
    )
}

formatKeyCodePhone = function (event) {
    const key = event.keyCode

    return (
        (key >= 48 && key <= 57) || // Allow number line
        (key >= 96 && key <= 105) || // Allow number pad
        (key === 189) || // Allow -
        (key === 8 || key === 46) || // Allow Backspace, Delete
        (
            // Allow Ctrl/Command + V,X,Z
            (event.ctrlKey === true || event.metaKey === true) &&
            (key === 86 || key === 88 || key === 90)
        )
    )
}

formatToPhone = (event) => {
    let caretPosition = event.target.selectionStart
    let inputRawLength = event.target.value.length

    const input = event.target.value.replace(/\D/g, '').substring(0, 10)
    const first = input.substring(0, 3)
    const middle = input.substring(3, 6)
    const last = input.substring(6, 10)

    let inputCleanLength = input.length

    let value

    if ([8, 46].includes(event.keyCode) && inputRawLength === 3) {
        value = first
    } else if ([8, 46].includes(event.keyCode) && inputRawLength === 7) {
        value = first + '-' + middle
    } else {
        if (inputCleanLength === 3 || inputCleanLength === 6) {
            caretPosition += 1
        }

        if (inputCleanLength > 5) {
            value = first + '-' + middle + '-' + last
        } else if (inputCleanLength > 2) {
            value = first + '-' + middle
        } else {
            value = first
        }
    }

    if (inputRawLength === caretPosition && value.length > caretPosition) {
        caretPosition += 1
    }

    event.target.value = value

    event.target.setSelectionRange(caretPosition, caretPosition)
}

formatToNumOnlyPhone = (event) => {
    // Only allow numbers, limit to 11 digits
    const input = event.target.value.replace(/\D/g, '').substring(0, 11)
    event.target.value = input
}

isAlphaString = function (string) {
    const regexMatch = /^[a-zA-Z\s-]+$/

    return !!string.match(regexMatch)
}

isEmailAddress = function (string) {
    const regexMatch = /^[\w\-\.\+]+\@[a-zA-Z0-9\.\-]+\.[a-zA-z0-9]{2,4}$/

    return !!string.match(regexMatch)
}

isPhone = function (string) {
    const regexMatch = /^(\+\d{1,2}\s)?\(?[23456789]\d{2}\)?[\s.-]\d{3}[\s.-]\d{4}/

    return !!string.match(regexMatch)
}

isNumOnlyPhone = function (string) {
    // Remove all non-numeric characters
    const cleaned = string.replace(/\D/g, '')

    // Check if it's a valid 10-digit US phone number
    if (cleaned.length === 10) {
        // Check if area code doesn't start with 0 or 1
        const areaCode = cleaned.slice(0, 3)
        return areaCode[0] !== '0' && areaCode[0] !== '1'
    }

    // Check if it's 11 digits starting with 1 (country code)
    if (cleaned.length === 11 && cleaned[0] === '1') {
        const areaCode = cleaned.slice(1, 4)
        return areaCode[0] !== '0' && areaCode[0] !== '1'
    }

    return false
}

smoothScrollingTo = function (targetElement) {
    targetElement.scrollIntoView({ //position is affected by css definition `scroll-margin-top`
        behavior: 'smooth'
    })
}

// ------------------------ toggle ------------------------ //

toggleLoading = function (inputElement, is_loading) {
    switch (inputElement.tagName) {
        case 'INPUT':
            toggleInputLoading(inputElement, is_loading)
            break
        case 'SELECT':
            toggleSelectLoading(inputElement, is_loading)
            break
    }
}

toggleInputLoading = function (inputElement, is_loading) {
    inputElement.classList.remove('is-invalid')
    inputElement.classList.remove('is-valid')

    let elementLoading = document.querySelector('#input-loading-' + inputElement.id)

    if (is_loading === true) {
        if (typeof (elementLoading) === 'undefined' || elementLoading === null) {
            let div = document.createElement('div')
            div.className = 'input-container'
            div.id = 'input-loading-' + inputElement.id

            let i = document.createElement('i')
            i.className = 'input-loading'

            div.appendChild(i)

            inputElement.parentNode.appendChild(div)
        }
    } else {
        if (typeof (elementLoading) != 'undefined' && elementLoading !== null) {
            elementLoading.remove()
        }
    }
}

toggleSelectLoading = function (inputElement, is_loading) {
    if (is_loading === true) {
        inputElement.classList.add('is-loading')
    } else {
        inputElement.classList.remove('is-loading')
    }
}

toggleValid = function (element, is_valid) {
    if (is_valid === true) {
        element.classList.remove('is-invalid')
        element.classList.add('is-valid')
    } else {
        element.classList.add('is-invalid')
        element.classList.remove('is-valid')
    }
}

toggleInputError = function (inputElement, stepElement, is_valid, with_error) {
    const id = inputElement.id

    toggleValid(inputElement, is_valid)

    const errorElement = stepElement.querySelector('#' + id + '_error');

    if (is_valid === false) {
        inputElement.focus()

        if (errorElement && with_error === true) {
            errorElement.style.display = 'block'
        }
    } else {
        if (errorElement) {
            errorElement.style.display = 'none'
        }
    }
}

toggleFormError = function (is_error) {
    const errorForm = document.querySelector('#SignupFormError');

    if (errorForm) {
        if (is_error === true) {
            errorForm.style.display = 'block'
        } else {
            errorForm.style.display = 'none'
        }
    }
}

//-------------------------- helpers  -------------------------- //

hasZipAddressDetails = function () {
    const zip_country = document.querySelector('#zip_country')
    const zip_state = document.querySelector('#zip_state')
    const zip_city = document.querySelector('#zip_city')

    if (zip_country.value.length > 0 && zip_state.value.length > 0 && zip_city.value.length) {
        return true
    }

    return false
}

hasGoogleAddressDetails = function () {
    const locality = document.querySelector('#locality')
    const route = document.querySelector('#route')

    if (locality.value.length > 0 && route.value.length > 0) {
        return true
    }

    return false
}

hasAddressDetails = function () {
    // if (hasZipAddressDetails() === false) {
    //     return hasGoogleAddressDetails()
    // }

    let inputAddress = document.querySelector('#address')
    let inputAddressCheck = document.querySelector('#address_check')

    if (inputAddress.value !== inputAddressCheck.value) {
        return false
    }

    return true
}

// ------------------------ address ------------------------ //

let googleMapLibraryIncluded = false
const componentForm = {
    street_number: 'short_name',
    route: 'long_name',
    locality: 'long_name',
    administrative_area_level_1: 'short_name',
    country: 'long_name',
    postal_code: 'short_name'
}

resetAddressComponent = function () { //address related
    for (const component in componentForm) {
        document.querySelector('#' + component).value = ''
    }
}

initAddressAutocomplete = function () { //address related
    if (googleMapLibraryIncluded === false) {
        loadScript('https://maps.googleapis.com/maps/api/js?key=' + mdrvConfigData.key.google + '&libraries=places&callback=addressAutocomplete', () => {
            googleMapLibraryIncluded = true
        })
    }
}

addressAutocomplete = function () {
    const inputAddress = document.querySelector('#address')

    let autocomplete = new google.maps.places.Autocomplete(inputAddress, {
        types: ['geocode']
    })

    autocomplete.setFields(['address_component'])

    autocomplete.addListener('place_changed', async () => {
        const place = autocomplete.getPlace()

        if (typeof place.address_components !== 'undefined') {
            document.querySelector('#address_check').value = inputAddress.value

            for (const component of place.address_components) {
                for (type of component.types) {
                    let addressType = type

                    if (addressType === 'sublocality_level_1') { //sometimes the `locality` is not set
                        addressType = 'locality'
                    }

                    if (componentForm[addressType]) {
                        document.querySelector('#' + addressType).value = component[componentForm[addressType]]
                    }
                }

            }
        }

        const stepData = getStepDataByID(options.stepAddress)
        let is_disabled = stepCheck[options.stepAddress](stepData['stepKey'], false, 'address')
        stepNextButtonStatus(stepData['stepKey'], is_disabled)
    })
}

// ------------------------ api ------------------------ //

getApiToken = function () {
    return decodeURI(readCookie('volpserve-bearer'))
}

twilioVerify = async function (string) {
    return await fetch(mdrvConfigData.api.phone_url + '/' + string, {
        headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            'Authorization': 'Bearer ' + getApiToken(),
        },
    })
        .then((response) => {
            if (response.ok) {
                return response.json()
            }
        })
        .then((response) => {
            return response.verified
        })
        .catch((error) => {
            return false
        })
}

getZipData = async function (string) {
    try {
        const response = await fetch(mdrvConfigData.api.zip_url + '/' + string, {
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'Authorization': 'Bearer ' + getApiToken(),
            },
        })

        if (response.ok) {
            return await response.json()
        } else {
            // console.error('Response not OK:', response.status, response.statusText)
            // Handle error scenarios if needed
            return {}
        }
    } catch (error) {
        // console.error('Error during fetch:', error)
        // Handle network errors or other issues
        return {}
    }
}
